import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { useSite } from "../context/SiteContext";
const LOGO_URL = "https://cdn.magicpatterns.com/uploads/6xvxXWGR6PhnV2LyYQmf5t/Agave-Family-Logo-Transparent.png";
const Taco = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-165" data-mp="l52g9sqkw7rw">
    <path d="M10 38C10 24.7452 20.7452 14 34 14H46C50.4183 14 54 17.5817 54 22V38C54 46.8366 46.8366 54 38 54H26C17.1634 54 10 46.8366 10 38Z" fill="#D6A632" data-id="element-166" data-mp="yvxqb8ctcux2" />
    <path d="M16 38C16 28.0589 24.0589 20 34 20H44C47.3137 20 50 22.6863 50 26V38C50 44.6274 44.6274 50 38 50H28C21.3726 50 16 44.6274 16 38Z" fill="#CE1126" data-id="element-167" data-mp="18v52vtbq4lj4" />
    <path d="M22 38C22 31.3726 27.3726 26 34 26H42C44.2091 26 46 27.7909 46 30V38C46 42.4183 42.4183 46 38 46H32C26.4772 46 22 41.5228 22 38Z" fill="#006847" data-id="element-168" data-mp="13x3klam4gq8p" />
    <path d="M28 38C28 34.6863 30.6863 32 34 32H40C41.1046 32 42 32.8954 42 34V38C42 40.2091 40.2091 42 38 42H34C30.6863 42 28 39.3137 28 38Z" fill="#F7F1E3" data-id="element-169" data-mp="35ogr243qn66v" />
  </svg>;
const Margarita = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-170" data-mp="2wonmibsofzod">
    <path d="M14 18L32 40L50 18H14Z" fill="#198FA8" fillOpacity="0.8" data-id="element-171" data-mp="31lnskmpj12fh" />
    <path d="M14 18L32 40L50 18H14Z" stroke="#F7F1E3" strokeWidth="3" strokeLinejoin="round" data-id="element-172" data-mp="36e76jks4lzkt" />
    <path d="M32 40V56" stroke="#F7F1E3" strokeWidth="3" strokeLinecap="round" data-id="element-173" data-mp="3bdtepft3kpmr" />
    <path d="M22 56H42" stroke="#F7F1E3" strokeWidth="3" strokeLinecap="round" data-id="element-174" data-mp="3gbv0i8hwr31x" />
    <circle cx="50" cy="18" r="7" fill="#CE1126" stroke="#F7F1E3" strokeWidth="2" data-id="element-175" data-mp="3gdxzhi11g6is" />
  </svg>;
const Burrito = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-176" data-mp="3pbi2avejuavi">
    <rect x="12" y="24" width="40" height="20" rx="10" fill="#F7F1E3" data-id="element-177" data-mp="1q0z27kmvo7nu" />
    <rect x="8" y="20" width="48" height="28" rx="14" stroke="#D6A632" strokeWidth="3" strokeDasharray="6 6" data-id="element-178" data-mp="1uy8pouqpi991" />
    <path d="M20 24V44" stroke="#CE1126" strokeWidth="4" strokeLinecap="round" data-id="element-179" data-mp="2y8wbd7fe05zm" />
    <path d="M44 24V44" stroke="#006847" strokeWidth="4" strokeLinecap="round" data-id="element-180" data-mp="2tautuqxm0eq9" />
  </svg>;
const PapelPicado = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-181" data-mp="37bnorcrtpbtw">
    <path d="M8 16H56V48L48 40L40 48L32 40L24 48L16 40L8 48V16Z" fill="#198FA8" data-id="element-182" data-mp="329ybrrl1io36" />
    <circle cx="32" cy="28" r="6" fill="#F7F1E3" data-id="element-183" data-mp="3h78spgggcm6a" />
    <circle cx="20" cy="28" r="3" fill="#F7F1E3" data-id="element-184" data-mp="3c9p69t9lp339" />
    <circle cx="44" cy="28" r="3" fill="#F7F1E3" data-id="element-185" data-mp="3c8xl7cdmqnr8" />
  </svg>;
const LimeSlice = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-186" data-mp="3q2yf9stmzml9">
    <circle cx="32" cy="32" r="24" fill="#006847" data-id="element-187" data-mp="3m1d206d6x6aj" />
    <circle cx="32" cy="32" r="20" fill="#F7F1E3" data-id="element-188" data-mp="3up00pdfsz93" />
    <circle cx="32" cy="32" r="18" fill="#006847" data-id="element-189" data-mp="3raw3cp4khzj" />
    <path d="M32 14V32L44.7279 19.2721" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-190" data-mp="3v0zto0g4axqe" />
    <path d="M32 32L19.2721 19.2721" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-191" data-mp="ihdz4q3s1aey" />
    <path d="M32 32L19.2721 44.7279" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-192" data-mp="nfp4oon1gyrd" />
    <path d="M32 32V50" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-193" data-mp="8iy3qaxpvezn" />
    <path d="M32 32L44.7279 44.7279" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-194" data-mp="dgzod0asjmd8" />
    <path d="M32 32H50" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-195" data-mp="3vvinxb8r8oc4" />
    <path d="M32 32H14" stroke="#F7F1E3" strokeWidth="2" strokeLinecap="round" data-id="element-196" data-mp="3vteao2oyucz6" />
  </svg>;
const Sparkle = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-197" data-mp="3ly47hbmtzzjt">
    <path d="M12 0C12 0 14 10 24 12C24 12 14 14 12 24C12 24 10 14 0 12C0 12 10 10 12 0Z" fill="#D6A632" data-id="element-198" data-mp="3qx7dozejsbtd" />
  </svg>;
const colors = ["#006847", "#CE1126", "#F7F1E3", "#198FA8", "#075985", "#D6A632", "#B85235"];
function CelebrationElements() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);
  const items = [{
    type: 'taco',
    ix: -50,
    iy: -50,
    tx: isMobile ? -20 : -30,
    ty: isMobile ? -35 : -25,
    r: 15,
    d: 0.1
  }, {
    type: 'margarita',
    ix: 50,
    iy: -50,
    tx: isMobile ? 20 : 30,
    ty: isMobile ? -30 : -20,
    r: -15,
    d: 0.2
  }, {
    type: 'burrito',
    ix: -50,
    iy: 50,
    tx: isMobile ? -25 : -25,
    ty: isMobile ? 35 : 25,
    r: -20,
    d: 0.3
  }, {
    type: 'papel',
    ix: 50,
    iy: 50,
    tx: isMobile ? 25 : 25,
    ty: isMobile ? 30 : 20,
    r: 25,
    d: 0.0
  }, {
    type: 'lime',
    ix: 0,
    iy: -60,
    tx: isMobile ? 10 : 15,
    ty: isMobile ? -40 : -30,
    r: 45,
    d: 0.2
  }, {
    type: 'sparkle',
    ix: -60,
    iy: 0,
    tx: isMobile ? -35 : -35,
    ty: isMobile ? -10 : 5,
    r: 15,
    d: 0.1
  }, {
    type: 'sparkle',
    ix: 60,
    iy: 10,
    tx: isMobile ? 35 : 35,
    ty: isMobile ? 10 : 0,
    r: -15,
    d: 0.3
  }, {
    type: 'margarita',
    ix: -20,
    iy: 60,
    tx: isMobile ? -15 : -15,
    ty: isMobile ? 40 : 30,
    r: 10,
    d: 0.4
  }, {
    type: 'burrito',
    ix: 20,
    iy: -60,
    tx: isMobile ? -10 : -10,
    ty: isMobile ? -45 : -30,
    r: -10,
    d: 0.2
  }];
  const confetti = Array.from({
    length: isMobile ? 16 : 32
  }).map((_, i) => {
    const angle = i / (isMobile ? 16 : 32) * Math.PI * 2;
    const dist = isMobile ? 35 : 45;
    const tx = Math.cos(angle) * dist;
    const ty = Math.sin(angle) * dist;
    return {
      ix: Math.cos(angle) * 100,
      iy: Math.sin(angle) * 100,
      tx,
      ty,
      r: Math.random() * 360,
      color: colors[i % colors.length],
      d: Math.random() * 0.4
    };
  });
  return <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-199" data-mp="41h6pnskd6b7">
      {items.map((item, i) => {
      if (isMobile && i > 5) return null;
      let Icon;
      if (item.type === 'taco') Icon = Taco;else if (item.type === 'margarita') Icon = Margarita;else if (item.type === 'burrito') Icon = Burrito;else if (item.type === 'papel') Icon = PapelPicado;else if (item.type === 'lime') Icon = LimeSlice;else Icon = Sparkle;
      return <motion.div key={`item-${i}`} className="absolute left-1/2 top-1/2 w-12 h-12 sm:w-16 sm:h-16 -ml-6 -mt-6 sm:-ml-8 sm:-mt-8" initial={{
        x: `${item.ix}vw`,
        y: `${item.iy}vh`,
        opacity: 0,
        rotate: 0,
        scale: 0.5
      }} animate={{
        x: [`${item.ix}vw`, `${item.tx}vw`, `${item.tx}vw`],
        y: [`${item.iy}vh`, `${item.ty}vh`, `${item.ty - 3}vh`],
        opacity: [0, 1, 0],
        rotate: [0, item.r, item.r + 15],
        scale: [0.5, 1, 0.9]
      }} transition={{
        duration: 1.8,
        delay: 0.6 + item.d,
        times: [0, 0.4, 1],
        ease: ["easeOut", "easeInOut"]
      }} data-id="element-200" data-mp="zqewxnx2rptp" data-mpi={i}>
            <Icon className="w-full h-full drop-shadow-lg" data-id="element-201" data-mp="3ubyxj4xatmte" />
          </motion.div>;
    })}

      {confetti.map((c, i) => <motion.div key={`confetti-${i}`} className="absolute left-1/2 top-1/2 w-2 h-4 sm:w-3 sm:h-6 -ml-1 -mt-2 sm:-ml-1.5 sm:-mt-3 rounded-sm" style={{
      backgroundColor: c.color
    }} initial={{
      x: `${c.ix}vw`,
      y: `${c.iy}vh`,
      opacity: 0,
      rotate: 0,
      scale: 0
    }} animate={{
      x: [`${c.ix}vw`, `${c.tx}vw`, `${c.tx + (Math.random() * 10 - 5)}vw`],
      y: [`${c.iy}vh`, `${c.ty}vh`, `${c.ty + 10}vh`],
      opacity: [0, 1, 0],
      rotate: [0, c.r, c.r + 180],
      scale: [0, 1, 0.5]
    }} transition={{
      duration: 1.5,
      delay: 0.5 + c.d,
      times: [0, 0.3, 1],
      ease: ["easeOut", "easeInOut"]
    }} data-id="element-202" data-mp="3pbtcw8pg50kt" data-mpi={i} />)}
    </div>;
}
export function WelcomeIntro() {
  const [isVisible, setIsVisible] = useState(false);
  const [isFirstVisit, setIsFirstVisit] = useState(true);
  const {
    t
  } = useSite();
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    try {
      const hasVisited = sessionStorage.getItem("agave-intro-played");
      if (!hasVisited) {
        setIsVisible(true);
        sessionStorage.setItem("agave-intro-played", "true");
        document.body.style.overflow = "hidden";
        const timer = setTimeout(() => {
          setIsVisible(false);
          document.body.style.overflow = "";
        }, 2600);
        return () => {
          clearTimeout(timer);
          document.body.style.overflow = "";
        };
      } else {
        setIsFirstVisit(false);
      }
    } catch (e) {
      // Fallback if sessionStorage is blocked
      setIsFirstVisit(false);
    }
  }, []);
  const handleSkip = () => {
    setIsVisible(false);
    document.body.style.overflow = "";
  };
  if (!isVisible && !isFirstVisit) return null;
  return <AnimatePresence data-id="element-203" data-mp="31bpr91fpuhgl">
      {isVisible && <motion.div className="fixed inset-0 z-[9999] flex items-center justify-center bg-matte overflow-hidden" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.6,
      ease: "easeInOut"
    }} data-id="element-204" data-mp="2wjpwdnei6eqv">
          {/* Golden Glow */}
          <motion.div className="absolute inset-0 flex items-center justify-center pointer-events-none" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.5,
        ease: "easeOut"
      }} data-id="element-205" data-mp="3dss43fy54w28">
            <div className="w-[70vw] h-[70vw] max-w-[600px] max-h-[600px] bg-gold/15 rounded-full blur-[80px] sm:blur-[120px]" data-id="element-206" data-mp="3msxb3ozf9sfv" />
          </motion.div>

          {/* Logo */}
          <motion.div className="relative z-10 flex items-center justify-center px-6 w-full" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-207" data-mp="ex5aie7jpar">
            <img src={LOGO_URL} alt="Agave Family" className="w-full max-w-[280px] sm:max-w-[480px] md:max-w-[600px] h-auto object-contain drop-shadow-2xl" fetchPriority="high" data-id="element-208" data-mp="ecvl7s86ftsd" />
          </motion.div>

          {/* Celebratory Elements */}
          {!prefersReducedMotion && <CelebrationElements data-id="element-209" data-mp="97u3y4smdd87" />}

          {/* Skip Button */}
          <motion.button className="absolute bottom-6 right-6 z-20 text-white/50 hover:text-white text-sm font-bold tracking-widest uppercase transition-colors px-4 py-2" onClick={handleSkip} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} data-id="element-210" data-mp="e0wyog94uspz">
            {t("Skip", "Saltar")}
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}